import React, { Component } from 'react';
import Icon from '../../icons/Icon';

class CustomEmptyComponent extends Component<Props> {
  render() {
    const { header, label } = this.props;

    return (
      <div className={'flex flex-col items-center justify-center w-full h-full'}>
        <div>
          <Icon icon={'no-folder'} size={110} />
        </div>
        <div></div>
        <div className={'px-5 py-5 bg-f-gray mt-5 rounded shadow-sm'}>{label && label}</div>
      </div>
    );
  }
}

interface Props {
  header?: string;
  label?: string;
}

export default CustomEmptyComponent;
